/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  Spinner,
  Button,
  Textarea,
  Select,
  FormControl,
  FormLabel,
  Alert,
  AlertIcon,
  SimpleGrid,
  Badge,
  useToast,
} from "@chakra-ui/react";

import axiosClient from "../../../../api/axiosClient";

export default function ReassignUserDialog({
  isOpen,
  onClose,
  departemenId,
  ticketId,
  onSuccess,
}) {
  const [items, setItems] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [alasan, setAlasan] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const toast = useToast();

  const normalizeItems = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    return [];
  };

  const getUserId = (item) => {
    return item?.user_id || item?.user?.id || "";
  };

  const getUserName = (item) => {
    return item?.user?.name || item?.name || "-";
  };

  const getUserRole = (item) => {
    return item?.user?.role || "-";
  };

  const getUserPhone = (item) => {
    return item?.user?.no_telepon || "-";
  };

  const getDepartemenName = (item) => {
    return item?.departemen?.name || "-";
  };

  const selectedItem = useMemo(() => {
    return items.find(
      (item) => String(getUserId(item)) === String(selectedUserId)
    );
  }, [items, selectedUserId]);

  const fetchUsers = async () => {
    if (!departemenId) {
      setItems([]);
      return;
    }

    try {
      setLoading(true);

      const res = await axiosClient.get(`/users/userByDepartemen/${departemenId}`);

      console.log("departemenId:", departemenId);
      console.log("users by departemen response:", res.data);

      const list = normalizeItems(res.data);

      setItems(list);
    } catch (error) {
      console.error(error);

      toast({
        title: "Gagal memuat teknisi",
        description: error.response?.data?.message || "Endpoint teknisi gagal",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setSelectedUserId("");
      setAlasan("");
      fetchUsers();
    }
  }, [isOpen, departemenId]);

    const handleSubmitApproval = async () => {
    if (!ticketId) {
        toast({
        title: "Ticket tidak ditemukan",
        status: "warning",
        });
        return;
    }

    if (!selectedUserId) {
        toast({
        title: "Pilih teknisi tujuan terlebih dahulu",
        status: "warning",
        });
        return;
    }

    try {
        setSubmitting(true);

        await axiosClient.post(`/ticket-transfer/create/${ticketId}`, {
        to_technician_id: selectedUserId,
        reason: alasan,
        });

        toast({
        title: "Pengajuan approval berhasil dikirim",
        description: `Request teknisi: ${getUserName(selectedItem)}`,
        status: "success",
        });

        onClose();
        onSuccess?.();
    } catch (error) {
        console.error(error);

        toast({
        title: "Gagal mengajukan approval",
        description:
            error.response?.data?.message || "Terjadi kesalahan pada server",
        status: "error",
        });
    } finally {
        setSubmitting(false);
    }
    };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
      <ModalOverlay />

      <ModalContent borderRadius="20px">
        <ModalHeader>Pilih Teknisi Tujuan</ModalHeader>
        <ModalCloseButton />

        <ModalBody pb={6}>
          {!departemenId && (
            <Alert status="warning" mb={4} borderRadius="12px">
              <AlertIcon />
              Departemen belum dipilih.
            </Alert>
          )}

          {loading ? (
            <Box textAlign="center" py={8}>
              <Spinner size="lg" />
              <Text mt={3} color="gray.500">
                Memuat teknisi...
              </Text>
            </Box>
          ) : (
            <>
              <FormControl mb={5} isRequired>
                <FormLabel>Request Teknisi Tujuan</FormLabel>

                <Select
                  placeholder={
                    items.length > 0
                      ? "Pilih teknisi tujuan"
                      : "Teknisi tidak tersedia"
                  }
                  value={selectedUserId}
                  onChange={(e) => setSelectedUserId(e.target.value)}
                  isDisabled={items.length === 0}
                >
                  {items.map((item) => {
                    const userId = getUserId(item);

                    return (
                      <option key={item.id} value={userId}>
                        {getUserName(item)} - {getUserRole(item)}
                      </option>
                    );
                  })}
                </Select>
              </FormControl>

              {items.length === 0 ? (
                <Alert status="info" mb={5} borderRadius="12px">
                  <AlertIcon />
                  Tidak ada user pada departemen ini.
                </Alert>
              ) : (
                <>
                  <Text fontWeight="700" mb={3}>
                    Daftar User Departemen
                  </Text>

                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={5}>
                    {items.map((item) => {
                      const userId = getUserId(item);
                      const isSelected =
                        String(selectedUserId) === String(userId);

                      return (
                        <Box
                          key={item.id}
                          borderWidth="2px"
                          borderRadius="xl"
                          p={4}
                          cursor="pointer"
                          bg={isSelected ? "blue.50" : "white"}
                          borderColor={isSelected ? "blue.500" : "gray.200"}
                          transition="all 0.25s ease"
                          _hover={{
                            shadow: "md",
                            transform: "translateY(-3px)",
                          }}
                          onClick={() => setSelectedUserId(String(userId))}
                        >
                          <Text fontWeight="bold">{getUserName(item)}</Text>

                          <Text fontSize="sm" color="gray.500">
                            No Telepon: {getUserPhone(item)}
                          </Text>

                          <Text fontSize="sm" color="gray.500">
                            Departemen: {getDepartemenName(item)}
                          </Text>

                          <Badge
                            mt={2}
                            colorScheme={
                              getUserRole(item) === "teknisi"
                                ? "purple"
                                : "gray"
                            }
                          >
                            {getUserRole(item)}
                          </Badge>

                          {isSelected && (
                            <Text
                              mt={2}
                              fontSize="sm"
                              fontWeight="bold"
                              color="blue.500"
                            >
                              ✓ Dipilih sebagai Request Teknisi
                            </Text>
                          )}
                        </Box>
                      );
                    })}
                  </SimpleGrid>
                </>
              )}

              <FormControl mb={5}>
                <FormLabel>Alasan Pengalihan</FormLabel>

                <Textarea
                  placeholder="Contoh: Ticket lebih sesuai ditangani teknisi hardware/software..."
                  value={alasan}
                  onChange={(e) => setAlasan(e.target.value)}
                />
              </FormControl>

              <Button
                colorScheme="blue"
                w="100%"
                isLoading={submitting}
                isDisabled={!selectedUserId}
                onClick={handleSubmitApproval}
              >
                Ajukan Approval Pengalihan
              </Button>
            </>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}